import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { investStrengthBonus } from "../../../store/actions";

interface IProps {
  generalId: number;
  tier: number;
  available: boolean;
  economist: boolean;
}

const mapDispatchToProps = (dispatch: any) => ({
  investStrengthBonusDispatch:
    (
      generalId: number,
      skillId: number,
      tier: number
    ) => dispatch(investStrengthBonus(generalId, skillId, tier))
})

const connector = connect(null, mapDispatchToProps);

const GeneralStrengthBonusInfo = ({
  generalId,
  tier,
  investStrengthBonusDispatch,
  available,
  economist
}: IProps & ConnectedProps<typeof connector>) => {
  const [selected, setSelected] = useState<number | null>(null);
  return (
    <>
      <h3 className="title">Strength bonus</h3>
      <p style={{ textAlign: "left" }}>
        <div className={available ? "" : "text-disabled"}>
          <div className={`radio-wrap ${available ? "" : "disabled"} ${selected === 1 ? "checked" : ""}`}
               onClick={() => available
                 && setSelected(1)}
          >
            <input
              type={"radio"}
              checked={selected === 1}
            />
          </div>
          {!economist ? "+2 ATT" : <>+5 <i className={"icon icon-pozemky middle"}/></>}
        </div>
        {!economist
        && <>
          <div className={available ? "" : "text-disabled"}>
            <div className={`radio-wrap ${available ? "" : "disabled"} ${selected === 2 ? "checked" : ""}`}
                 onClick={() => available
                   && setSelected(2)}
            >
              <input
                type={"radio"}
                checked={selected === 2}
              />
            </div>
            +2 DEF
          </div>
          <div className={available ? "" : "text-disabled"}>
            <div className={`radio-wrap ${available ? "" : "disabled"} ${selected === 3 ? "checked" : ""}`}
                 onClick={() => available
                   && setSelected(3)}
            >
              <input
                type={"radio"}
                checked={selected === 3}
              />
            </div>
            +1 ATT & DEF
          </div>
        </>
        }
      </p>
      <p>
        <a href="#"
           className={
             `btn btn-black btn-sm ${available && selected ? "" : "disabled"}`
           }
           onClick={() => (available && selected
             ? investStrengthBonusDispatch(generalId, selected, tier) : null)}
        >
          Invest 1 point
        </a>
      </p>
    </>
  )
}

export default connector(GeneralStrengthBonusInfo);
